<template>
  <article class="px-6 py-4 flex flex-col bg-white mb-4 shadow-lg relative">
    <div class="flex flex-1 items-baseline border-b mb-4 pb-4">
      <h1 class="flex-1 text-2xl leading-tight">
        {{ competition.title }}
      </h1>
      <div class="ml-4 w-48 flex-no-shrink">
        <app-button
          tag="a"
          :href="submissionsLink()"
        >
          Submissions
        </app-button>
      </div>
    </div>
    <div class="flex items-center">
      <app-badge
        v-if="competition.private"
        icon="security-check"
        :type="competitionBadge.type"
        class="mr-4"
      >
        Private
      </app-badge>
      <p
        class="flex items-center text-xs font-bold uppercase tracking-wide leading-none mr-4"
        :class="`text-${competitionBadge.type}-700`"
      >
        <icon
          :icon="competitionBadge.icon"
          class="w-5 h-5 mr-1 mb-0"
          :class="`icons-${competitionBadge.type}`"
        />
        {{ competitionBadge.text }}
      </p>
      <p
        class="text-xs mr-4 border rounded px-2 bg-primary-200 border-primary-400 text-primary-800"
      >
        <b class="pr-2">Total</b> Started: {{ competition.applications_total_count }} | Submitted: {{ competition.applications_submitted_count }}
      </p>
      <p
        v-for="({ started, submitted, stream }, index) in competition.applications"
        :key="`stream-${index}`"
        class="text-xs mr-4 border rounded px-2"
        :style="{
          backgroundColor: findStreamColorsByKey(competition.streams, stream).backgroundColor,
          borderColor: findStreamColorsByKey(competition.streams, stream).borderColor,
          color: findStreamColorsByKey(competition.streams, stream).color,
        }"
      >
        <b class="pr-2">{{ findStreamNameByKey(competition.streams, stream) }}</b> Started: {{ started }} | Submitted: {{ submitted }}
      </p>
      <icon-link
        v-if="competition.applications_submitted_count > 0"
        icon="cloud-download"
        :href="
          route('funding.competitions.export', {
            funding: $page.funding_pot.id,
            competition: competition.uuid
          })
        "
        target="_blank"
        class="ml-auto"
      >
        Export
      </icon-link>
    </div>
  </article>
</template>

<script>
import { format, parseISO, differenceInCalendarDays } from "date-fns";
import { competitionStreamsMixin } from "../../mixins/competitionStreams";
export default {
  name: "AdminDashboardFundingPotCompetition",
  mixins: [competitionStreamsMixin],
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  computed: {
    competitionRoute() {
      return {
        funding: this.competition.funding_pots[0].id,
        competition: this.competition.uuid
      };
    },
    competitionBadge() {
      const comp = this.competition;
      const badgeContent = {
        icon: "",
        text: "",
        type: ""
      };
      const activeStatus = Object.keys(comp.statuses).filter(
        status => comp.statuses[status]
      );
      if (activeStatus.includes("open")) {
        badgeContent.icon = "text-cursor";
        badgeContent.text = "Open";
        badgeContent.type = "positive";
      } else if (
        activeStatus.includes("closed") &&
        activeStatus.includes("active")
      ) {
        badgeContent.icon = "check";
        badgeContent.text = "Active";
        badgeContent.type = "positive";
      } else if (activeStatus.includes("closed")) {
        badgeContent.icon = "check";
        badgeContent.text = "Completed";
        badgeContent.type = "grey";
      } else if (activeStatus.includes("scheduled")) {
        badgeContent.icon = "time";
        badgeContent.text =
          "Scheduled: " +
          format(parseISO(comp.application_start_date), "do MMMM yyyy");
        badgeContent.type = "positive";
      }
      return badgeContent;
    }
  },
  methods: {
    dateCount(from, to) {
      if (!from || !to) return;
      const pf = parseISO(from);
      const pt = parseISO(to);
      return `[${differenceInCalendarDays(pt, pf)} days]`;
    },
    formatDate(date) {
      if (!date) return "TBC";
      return format(parseISO(date), "do MMMM yyyy");
    },
    submissionsLink() {
      const params = {
        funding: this.$page.funding_pot.id
      };

      const key = this.competition.type.key.toLowerCase();

      if (key == "eoi") {
        return this.route("funding.eoi.index", params);
      }

      params.type = key;
      return this.route("funding.applications.index", params);
    }
  }
};
</script>
